import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const r = await api.post("/newsletter", { email });
      toast.success(r.data.message || "Subscribed!");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="relative bg-primary text-black px-6 md:px-12 lg:px-16 py-24 md:py-32 overflow-hidden">
      <div className="relative max-w-4xl">
        <h2 className="font-anton text-5xl sm:text-7xl lg:text-8xl uppercase leading-[0.85]">
          Get the<br /><span className="outline-volt" style={{ WebkitTextStroke: "2px #050505" }}>next drop</span> first.
        </h2>
        <p className="text-black/70 mt-8 max-w-lg font-medium text-lg">
          Early access, restock alerts, and members-only jersey blends. No spam — just heat.
        </p>
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-4 mt-10 max-w-xl">
          <input
            data-testid="newsletter-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            required
            className="flex-1 bg-transparent border-b-2 border-black/40 focus:border-black outline-none py-4 text-black placeholder:text-black/50 text-lg"
          />
          <button
            data-testid="newsletter-submit"
            type="submit"
            disabled={loading}
            className="bg-black text-primary hover:bg-white hover:text-black px-8 py-4 font-bold uppercase tracking-[0.2em] text-sm transition-colors active:scale-95 flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? "..." : "Join"}
            <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </section>
  );
}
